import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { selectSession } from '../model/selectors';
import { SessionType, isRunningLocal, builtEnvironment } from '@shared';


export function OnboardingRedirect() {
  const { formReferenceId } = useParams<{ formReferenceId: string }>();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const session = useSelector(selectSession);
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    if (!formReferenceId || hasRedirected) {
      return;
    }

    if (authLoading) {
      return;
    }

    if (isAuthenticated && session.sessionType === SessionType.unknown) {
      return;
    }

    if (isAuthenticated && (session.sessionType === SessionType.client || session.sessionType === SessionType.advisor || session.sessionType === SessionType.wizard)) {
      setHasRedirected(true);
      navigate(`/onboarding-form/${formReferenceId}`, { replace: true });
      return;
    }

    // Unauthenticated users - redirect to login
    if (!isAuthenticated) {
      setHasRedirected(true);
      
      async function handleRedirect() {
        try {
          const env = isRunningLocal() ? 'dev' : builtEnvironment;
          const response = await fetch(`/${env}/api/onboarding/${formReferenceId}`);
          
          if (!response.ok) {
            navigate('/');
            return;
          }

          const data = await response.json();
          if (data.localStorageAllowed === true && data.surveyUrl) {
            window.location.href = data.surveyUrl;
          } else {
            window.location.href = data.redirectUrl;
          }
        } catch (error) {
          console.error('Error fetching onboarding redirect:', error);
          navigate('/');
        }
      }

      handleRedirect();
    }
  }, [formReferenceId, navigate, isAuthenticated, authLoading, session.sessionType, hasRedirected]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
      </div>
    </div>
  );
}

